import { useMemo } from 'react';

export default function PdfPreview({ url }) {
  const normalizedUrl = useMemo(() => (
    typeof url === 'string' ? encodeURIComponent(url) : url
  ), [url]);

  const viewerUrl = `https://docs.google.com/gview?embedded=true&url=${normalizedUrl}`;

  return (
    <iframe
      src={viewerUrl}
      title="PDF Preview"
      className="w-full h-full border-0"
    />
  );
}
